import api from "../index";

export const GetSalesUsersApi = (params) =>
  api.post(`Sales/get-sales-users?${params}`);

export const UpdateSalesUserStatusApi = (data) =>
  api.put("Sales/user-sales-status", data);

export const UpdateUserSalesAgentApi = (data) =>
  api.put("Sales/user-sales-agent", data);
